import React, { useCallback, useMemo } from "react"
import _ from "lodash"
import {
  useTheme,
  Avatar,
  ListItemButton,
  Box,
  Stack,
  Typography,
} from "@mui/material"
import clsx from "clsx"
import { YouAreHereChipIcon } from "../icons"
import { DEFAULT_VENUE_FILTER } from "../../constant"
import { useTranslation } from "providers/i18n"

export const VenueSelector = (props) => {
  const {
    venues = [],
    onClickVenue = () => {},
    selectedVenue,
    currentVenue = null,
  } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const allVenueFilterLogo = useMemo(
    () => theme?.assets?.venueFilter?.all?.url,
    [theme]
  )

  const { styleOverrides = {} } = theme.components[`VenueSelector`] || {}

  const isFilteredByAllVenue = useMemo(
    () => selectedVenue === DEFAULT_VENUE_FILTER,
    [selectedVenue]
  )

  const {
    root,
    buttonWrapper,
    button,
    icon,
    currentVenueChip,
    allVenueIcon,
    allVenueLabel,
  } = styleOverrides
  const handleClick = useCallback(
    (venueId) => () => {
      onClickVenue(venueId)
    },
    [onClickVenue]
  )
  if (venues.length === 0) return null
  return (
    <Stack direction="row" sx={root}>
      <Box
        className={clsx("all", { selected: isFilteredByAllVenue })}
        key={"all"}
        sx={buttonWrapper}
      >
        <ListItemButton
          sx={button}
          onClick={handleClick(DEFAULT_VENUE_FILTER)}
          selected={isFilteredByAllVenue}
        >
          <Avatar alt="all-logo" src={allVenueFilterLogo} sx={allVenueIcon} />
          <Typography sx={allVenueLabel}>{t("All Mall")}</Typography>
        </ListItemButton>
      </Box>
      {venues.map((venue) => {
        const { id } = venue
        const isSelectedVenue = selectedVenue === id
        const logo =
          _.get(venue, "properties.logo_simple.url") ||
          _.get(venue, "properties.logo.url") ||
          ""
        const ref = _.get(venue, "properties.reference", "")
        const isCurrentVenue = currentVenue === venue.id
        return (
          <Box
            key={id}
            className={clsx(ref, { selected: isSelectedVenue })}
            sx={buttonWrapper}
          >
            <ListItemButton
              selected={isSelectedVenue}
              sx={button}
              onClick={handleClick(id)}
            >
              <Avatar alt="venue-logo" src={logo} sx={icon} />
            </ListItemButton>
            {isCurrentVenue && <YouAreHereChipIcon sx={currentVenueChip} />}
          </Box>
        )
      })}
    </Stack>
  )
}
